import { render, staticRenderFns } from "./alimentos-tabs.vue?vue&type=template&id=0c15d1ce&"
import script from "./alimentos-tabs.vue?vue&type=script&lang=js&"
export * from "./alimentos-tabs.vue?vue&type=script&lang=js&"
import style0 from "./alimentos-tabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports